import React from 'react';
import { useAsync } from 'react-async-hook';
import { isString } from 'lodash';
import Plyr from '@lwtears/lwt-common-frontend/lib/Player/';
import ApplicationIFrame from '@lwtears/lwt-common-frontend/lib/ApplicationFrame';
import { appendSessionToUrl, getLiteSession } from 'api/lite-session';
import { AppNames, Frametype } from 'types';
import { isAVPlayer } from 'util/resources-util';

type Props = {
  handleClose: VoidFunction | undefined;
  frameType: Frametype;
  eventLogger: () => void;
  onLoad?: VoidFunction | undefined;
  onMount?: VoidFunction | undefined;
  isFullScreen?: boolean;
  style?: React.CSSProperties;
  selectedResource: {
    url: string;
    title: string;
    resourceType: any;
    showResourcePlayer: boolean;
    mediaType: string;
    fileExtension: string;
    id: any;
    type?: any;
    aspectRatio?: string;
    heightAdjust?: number;
    data: any;
  };
};

const getUrl = async (url: string, resourceType?: any) => {
  // Seems that 'resourceType' is a string when accessed from the 'Resources' screen and other times
  // it's an object (from 'Student Workbook', 'Digital Formation Tools' screens), so do some wonky checking here.
  const type = isString(resourceType) ? resourceType : resourceType?.type;

  if (type === 'wdt') {
    const { sessionId } = await getLiteSession(AppNames.GSS);
    return appendSessionToUrl(url, sessionId);
  }

  return url;
};

const ResourceModal = ({
  selectedResource: {
    title,
    url,
    resourceType,
    fileExtension,
    mediaType,
    aspectRatio,
    heightAdjust,
    data,
    type
  },
  frameType,
  isFullScreen,
  style,
  handleClose,
  eventLogger,
  onLoad,
  onMount
}: Props) => {
  const handleOnLoad = () => {
    if (onLoad) onLoad();
    eventLogger();
  };

  const handleOnMount = () => {
    if (onMount) onMount();
  };

  const { result: applicationUrl } = useAsync(getUrl, [url, type]);

  if (isAVPlayer(frameType)) {
    return (
      <Plyr
        style={
          {
            height: 'auto',
            width: '80vw',
            maxHeight: isFullScreen ? '95%' : '100%',
            '& > div:first-of-type': {
              height: '100%'
            } as any,
            ...(style ?? {})
          } as any
        }
        key={resourceType}
        aspectRatio={aspectRatio?.toString()}
        media={{
          type: mediaType || data.mediaType,
          source: {
            src: url || data.src,
            type: `${mediaType || data.mediaType}/${fileExtension || data.fileExtension}`
          }
        }}
        config={{
          fullscreen: {
            enabled: !isFullScreen
          }
        }}
        title={title}
        onDone={handleClose}
        onLoad={handleOnLoad}
      />
    );
  }

  // TODO: Error handling/spinner necessary here?
  if (!applicationUrl) return null;

  return (
    <ApplicationIFrame
      aspectRatio={aspectRatio?.toString() ?? data?.aspectRatio?.toString() ?? ''}
      heightAdjust={heightAdjust ?? data?.heightAdjust ?? 0}
      url={applicationUrl}
      onLoad={handleOnLoad}
      onMount={handleOnMount}
    />
  );
};
export default ResourceModal;
